import Doms from "oc-commons/Doms.js";

Doms.handlebarsRegisterSafe({

    /**
     * baut eine URL zu einer Datei aus dem Content-Verzeichnis zusammen.
     * @example
     * background-image:url({{contentUrl 'productThumbs/' (encodeURIComponent ArtikelID) '_1.jpg'}});
     */
    contentUrl: function() {
        return APP.settings.wkfgContentBaseUrl + Array.from(arguments).slice(0,-1).join('');
    },

});
